module.exports = __webpack_public_path__ + "img/gallery02.213f7543.jpg";